import { render, staticRenderFns } from "./LessonStatusDropdown.vue?vue&type=template&id=0536c89b&"
import script from "./LessonStatusDropdown.vue?vue&type=script&lang=ts&"
export * from "./LessonStatusDropdown.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports